import React, { useState } from "react";
import "./MolGrid.scss";
import Image from "../image/Image";
import { AppIcons } from "../../data/appIcons";

const MolGridHeader = (props) => {
  const [shortingColumn, setToggleShort] = useState(false);
  const toggleShort = () => {
    setToggleShort(!shortingColumn);
  };
  const handleShortColumn =(col)=> {
    if(props.onShorting)
    props.onShorting(col.fieldName);
}
  const renderShortColumn =(col)=>{
    let shortColObj = props.selectedShorting.find(s=>s.fieldName === col.fieldName)
    return (
      <>
        <div
          className={`shorting-part ${shortColObj && shortColObj.isAce ? "short-column" : ""
            }`}
        >
          <button type="button" onClick={() => { handleShortColumn(col) }}>
            <span>{col.name}</span>
            <Image
              imgCustomClassName="order-icon"
              imagePath={AppIcons.shortingArrowIcon}
              altText="Arrow Icon"
            />
          </button>
          {shortColObj ?
            <span className="sort-priority-number" >
              {shortColObj.shortNumber}
            </span> : null
          }
        </div>
      </>

    )

  }
  return (
    <tr>
      {props.columns.map((col, index) => (
        <th key={`col_${index}`} className="whitespace-nowrap">
          {col.allowShort ? (
            <span className="heading-shorting">
              {renderShortColumn(col)}
            </span>
          ) : (
            <>{col.name}</>
          )}
        </th>
      ))}
    </tr>
  );
};

export default MolGridHeader;
